import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { v4 as uuidv4 } from 'uuid';
import type { AccountChannel, AgentChannel } from '@/shared/model/collection-channel.model';

@Component({
  computed: {},
  methods: {},
  components: {},
})
export default class CollectionChannelCard extends Vue {
  @Prop({ required: true }) public readonly accountChannel!: AccountChannel;

  @Emit('account:change') changeAccount() {}

  @Emit('account:unlink') unlinkAccount() {}

  @Emit('agent:update') updateAgent(agent: AgentChannel) {}

  state = {
    instanceId: null,
  };

  mounted() {
    this.state.instanceId = uuidv4().toString();
  }

  valueDataSource(value: string) {
    if (!value) return '';
    const arrValue = JSON.parse(value);
    if (!arrValue || !arrValue.length) return '';
    return arrValue.join(', ');
  }

  navigate2Bp(bpId: string) {
    this.$router.push('/scrap-agent/' + bpId).then();
  }
}
